<template>
    <div class="content">
        <div class="about_content">



            <img src="@/assets/walfare.svg" class="img_photos">
            <div class="description">
                <h4>MIKでは、社員が働きやすいよう、<br>以下のような福利厚生を整えています。
                    <br> 当たり前に感じられるものもあれば、MIK独自のものもあります。<br><br>
                    独自の制度は、社員の声を聞きながら<br>
                    一つ一つ誕生してきました。

                    <br>MIKはまだまだ発展途上。<br>
                    これからも、より社員がやる気を出せるような制度を<br>どんどん生み出していきます。
                    <br><br>
                </h4>
            </div>
            <div class="item_mini_box" v-if="!fukuri_items.some(item => item.is_open)">
                <div class="item_mini_fukuri" @click="handleChangeFukuriItem(index)"
                    v-for="(item, index) in fukuri_items" :key="item">
                    <h3>{{ item.title }}</h3>
                    <div>{{ item.sub }}</div>
                </div>
            </div>

            <div v-for="(answer, index) in fukuri_items" :key="answer">
                <div class="answer_item" v-if="answer.is_open">

                    <div @click="handleChangeFukuriItem(index)" class="answer_close">×</div>
                    <h3>{{ answer.title }}</h3>
                    <h5>{{ answer.sub }}</h5>
                    <p>{{ answer.answer }}</p>
                </div>
            </div>


        </div>
    </div>









</template>
<script>
export default {
    data() {
        return {

            fukuri_items: [{ title: "各種社会保険完備", sub: "", is_open: false, answer: "「健康保険」「厚生年金保険」「雇用保険」「労災保険」への加入", img: "" },
            { title: "交通費支給", sub: "上限30,000円", is_open: false, answer: "自宅から勤務場所への最短経路により算出します。公共交通機関利用の場合は最大30,000円、このほか、勤務地によってはマイカー通勤も可能な場合があります。", img: "" },
            { title: "年間休日124日以上", sub: "", is_open: false, answer: "土日祝日は原則休み。配属先によっては、土日祝に出勤し、別の日に振り返る場合もあります。年末年始、夏季休暇ももちろんあります。", img: "" },
            { title: "副業OK", sub: "", is_open: false, answer: "弊社は副業OKです。弊社で働きながら、フリーランスで働いても、別の会社で働いても、会社を興しても構いません。チャレンジ精神のある社員の気持ちを大切にしたい、という会社の方針です。", img: "" },
            { title: "有休の利用が簡単", sub: "", is_open: false, answer: "有給の利用は社内システムから前日までに登録すれば利用可能です。", img: "" },
            { title: "テレワーク勤務可能", sub: "※諸条件あり", is_open: false, answer: "テレワークを希望する方には、優先してテレワークが可能な配属先への配属を検討いたます。配属先の業務によりテレワークが不可な場合もありますので、ご希望に添えない場合もございます。", img: "" },
            { title: "時短勤務可能", sub: "※諸条件あり", is_open: false, answer: "時短勤務を希望される方には、時短勤務が可能な配属先への配属を検討します。配属先によっては時短勤務が難しい場合もありますので、ご希望に添えない場合もございます。", img: "" },
            { title: "オンライン研修", sub: "", is_open: false, answer: "研修はオンラインにて行います。未経験者の方には、マンツーマンで、学習者のペースに合わせて学習を行います。PCをお持ちでない方には、自社PCを貸与いたします。", img: "" },
            { title: "MIKがんばったMVP", sub: "", is_open: false, answer: "毎年１回、社内で公募により頑張った社員を募り、MVPを選出します。MVPの方は、賞金最大5万円が受け取れます。", img: "" },
            { title: "社内貢献ポイント制度", sub: "", is_open: false, answer: "毎月の皆勤賞や各種アンケートへの回答、イベントなどで社内貢献ポイントを獲得することができます。このポイントはご自身のタイミングで換金することができ、申請後の給与時にインセンティブとして支払われます。", img: "" },
            { title: "社内交流会・勉強会", sub: "", is_open: false, answer: "新人歓迎会や忘年会など、集まるタイミングを増やし、社員同士が顔を合わせる機会をなるべく増やすようにしています。", img: "" },
            ]
        }
    },
    methods: {
        handleChangeFukuriItem(index) {
            this.fukuri_items.forEach((item, i) => {
                item.is_open = i === index ? !item.is_open : false;
            })
        }
    }

}
</script>
<style>
.about_content {
    width: 550px;
    text-align: center;
    line-height: 30px;
}

.item_mini_fukuri {

    font-size: 14px;
    width: 100px;
    height: 50px;
    background-color: deepskyblue;
    color: white;
    border-radius: 10px;
    padding: 20px;
    margin: 10px;

    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    transition: 300ms;
    cursor: pointer;

}

.item_mini_fukuri:hover {
    transition: 300ms;
    transform: scale(1.05)
}

.item_mini h5 p {
    margin: 0px;
}

.item_mini_box {
    width: 600px;
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: center;


}



.answer_item {
    width: 500px;
    height: 250px;
    background-color: #fff;
    border-radius: 10px;
    padding: 20px;
    margin: 20px;
    text-align: center;
    border: 2px solid black;
    position: relative
}

.answer_close {
    position: absolute;
    top: 20px;
    right: 20px;
    font-size: 18px;
    font-weight: bold;
    cursor: pointer;
    transition: 300ms;
}

.answer_close:hover {
    transition: 300ms;
    transform: scale(1.55)
}

@media(max-width:500px) {
    .about_content {
        width: 100%;
    }

    .answer_item {
        width: 280px;
        padding: 10px;
    }

    .item_mini_box {
        width: 320px;
        display: flex;
        flex-wrap: wrap;
        align-items: center;
        justify-content: center;
    }

    .description {
        width: 320px;
    }
}
</style>